var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.804 12.9319C22.3542 9.40242 27.9514 7.49106 33.71 7.50003C48.07 7.50003 59.71 19.14 59.71 33.5C59.71 47.86 48.07 59.5 33.71 59.5C19.35 59.5 7.70996 47.86 7.70996 33.5C7.70996 30.302 8.28999 27.2399 9.34399 24.4099",
    fill: "#4BBFEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.804 12.9319C22.3542 9.40242 27.9514 7.49106 33.71 7.50003C48.07 7.50003 59.71 19.14 59.71 33.5C59.71 47.86 48.07 59.5 33.71 59.5C19.35 59.5 7.70996 47.86 7.70996 33.5C7.70996 30.302 8.28999 27.2399 9.34399 24.4099",
    stroke: "#2B4255"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.804 12.9319C22.3542 9.40239 27.9514 7.49103 33.71 7.5C48.07 7.5 59.71 19.14 59.71 33.5C59.71 47.86 48.07 59.5 33.71 59.5C19.35 59.5 7.70996 47.86 7.70996 33.5C7.70996 30.302 8.28999 27.2399 9.34399 24.4099M33.71 7V59.438M59.836 33.5H7.836M41.574 19.5H17.398M55.658 47.5H11.898",
    stroke: "#2B4255"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.128 59.512C24.214 53.704 19.71 44.218 19.71 33.5C19.71 22.816 24.186 13.3559 31.064 7.54395M36.256 59.53C43.314 51.97 47.6 41.804 47.728 33.5M43.556 16.5059C41.69 13.0279 39.266 9.99999 36.434 7.59399",
    stroke: "#2B4255"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.422 16.2681C18.422 20.0061 11.71 27.5 11.71 27.5C11.71 27.5 5 20.0061 5 16.2681C5 12.5301 8.00396 9.5 11.71 9.5C15.418 9.5 18.422 12.5301 18.422 16.2681Z",
    fill: "#E9EDED",
    stroke: "#FFB62A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7101 17.772C12.945 17.772 13.9461 16.7618 13.9461 15.5159C13.9461 14.2699 12.945 13.26 11.7101 13.26C10.4752 13.26 9.47412 14.2699 9.47412 15.5159C9.47412 16.7618 10.4752 17.772 11.7101 17.772Z",
    fill: "#4BBFEB",
    stroke: "#FFB62A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.422 22.2681C54.422 26.0061 47.71 33.5 47.71 33.5C47.71 33.5 41 26.0061 41 22.2681C41 18.5301 44.004 15.5 47.71 15.5C51.418 15.5 54.422 18.5301 54.422 22.2681Z",
    fill: "#E9EDED",
    stroke: "#FFB62A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7101 23.772C48.945 23.772 49.9461 22.7618 49.9461 21.5159C49.9461 20.2699 48.945 19.26 47.7101 19.26C46.4752 19.26 45.4741 20.2699 45.4741 21.5159C45.4741 22.7618 46.4752 23.772 47.7101 23.772Z",
    fill: "#4BBFEB",
    stroke: "#FFB62A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.77537c7b1b1dfff2547ee77fd40fe070.svg";
export { ForwardRef as ReactComponent };